import React from "react";

const SetUpModelIcon = ({ fill }) => (
  <svg
    width="40"
    height="38"
    viewBox="0 0 40 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.2969 0.296875H23.7031V9.70312H14.2969V0.296875ZM0.296875 28.2969H9.70312V37.7031H0.296875V28.2969ZM0.296875 14.2969H9.70312V23.7031H0.296875V14.2969ZM0.296875 0.296875H9.70312V9.70312H0.296875V0.296875ZM23.7031 19.9844V14.2969H14.2969V23.7031H19.9844L23.7031 19.9844ZM39.6719 17.3594L36.9375 14.625C36.7917 14.4062 36.5729 14.2969 36.2812 14.2969C36.0625 14.2969 35.8438 14.4062 35.625 14.625L33.5469 16.7031L37.7031 20.75L39.6719 18.6719C39.8906 18.526 40 18.3073 40 18.0156C40 17.724 39.8906 17.5052 39.6719 17.3594ZM16.7031 33.5469V37.7031H20.75L36.2812 22.0625L32.2344 18.0156L16.7031 33.5469ZM28.2969 0.296875H37.7031V9.70312H28.2969V0.296875Z"
      fill={fill || "#7EC7BD"}
    />
  </svg>
);

export default SetUpModelIcon;
